import React from "react";
export const StatsValuesRibbon = ({ subTitle, title }) => (React.createElement("div", { className: "options-wrapper__option" },
    React.createElement("p", { className: "options-wrapper__option__p-title" }, title),
    React.createElement("div", { className: "options-wrapper__option__p-subtitle", dangerouslySetInnerHTML: {
            __html: subTitle || ""
        } })));
